import { observable, action } from 'mobx'
import Api from '@api/hotel/settlementManage'
import { message } from 'hljd'
import indexStore from '../store'

class Store {
  @observable id = ''

  @action
  havePay = async () => {
    const { id } = this
    let { msg, RetCode } = await Api.payApi({
      order_id: id,
      pay_type: 'offline'
    })
    if (RetCode == 0) {
      indexStore.status = '1'
      this.disabled = true
    } else {
      return message.warning(msg)
    }
  }

  @observable disabled = indexStore.status != 0
}
export default new Store()
